import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'emptyValue'
})
export class EmptyValuePipe implements PipeTransform {

  transform(value: any, ...args: unknown[]): any {
    if(value) {
      return value;
    } else {
      return '--';
    }
  }

}
